import React from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import { Row, Col } from "reactstrap";
import ModalFrame from "../../../toolkit/modalFrame";
import s from "./styles.scss";
import { serviceCaller, ServiceCallerProps } from "../../composition";
import IColumnName from "../../../types/IColumnName";

interface Props extends ServiceCallerProps {
  isOpen: boolean;
  changeColumnFunction: (index) => void;
  columnNames: Array<IColumnName>;
  toggle: () => void;
}

class ColumnModals extends React.Component<Props> {
  getRowsToRender = () => {
    let rows = [];
    this.props.columnNames.forEach((colName, index) => {
      rows.push(
        <Row key={colName.key}>
          <Col xs={4} className={s.checkCol}>
            <input
              id={colName.key}
              name={colName.key}
              type="checkbox"
              checked={!colName.isDisabled}
              onChange={() => this.props.changeColumnFunction(index)}
            />
            <label
              className={!colName.isDisabled ? s.checkAll : s.noCheck}
              htmlFor={colName.key}
            />
          </Col>
          <Col xs={8}>
            <span className={s.name}>{colName.key}</span>
          </Col>
        </Row>
      );
    });
    return rows;
  };

  render() {
    return (
      <ModalFrame
        title={`Columns Management`}
        isOpen={this.props.isOpen}
        toggle={this.props.toggle}
      >
        {this.props.columnNames && this.getRowsToRender()}
      </ModalFrame>
    );
  }
}

export default serviceCaller(withStyles(s)(ColumnModals));
